import { useContext } from 'react';

import { SuiWalletContext } from './sui-wallet-provider';
import type { UserSuiWalletState } from './use-privy-wallet';

export function useUserSuiWallet(): UserSuiWalletState {
  const wallet = useContext(SuiWalletContext);

  if (!wallet) {
    throw new Error('useUserSuiWallet must be used within SuiWalletProvider.');
  }

  return wallet;
}
